(() => {
  if (window.gamedayFieldSharing) return;
  window.gamedayFieldSharing = true;
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-field-share]');
    if (!button) return;
    const status = button.closest('.gf-journal-share').querySelector('[data-field-share-status]');
    const url = button.dataset.shareUrl || location.href;
    const title = button.dataset.shareTitle || document.title;
    try {
      if (navigator.share) await navigator.share({title, url});
      else { await navigator.clipboard.writeText(url); status.textContent = 'Link copied. Ready for your crew.'; }
    } catch (error) {
      if (error.name !== 'AbortError') status.textContent = 'Use the email link to share this Field Note.';
    }
  });
})();
